<script setup>
import IconBase from '@/components/icon/IconBase.vue'
import IconWarningTriangleFilled from '@/components/icon/IconWarningTriangleFilled.vue'

const emit = defineEmits(['view-detail'])
</script>

<template>
	<div
		class="flex items-start gap-2 rounded-md px-3 py-2.5 text-tiny leading-5 text-error"
		style="background-color: var(--error-transparent); border-color: rgba(222, 94, 94, 0.4);"
		role="alert"
	>
		<icon-base class="shrink-0 mt-0.5" aria-hidden="true">
			<icon-warning-triangle-filled />
		</icon-base>
		<p class="m-0">
			Your TV Playout exceeds the limits of your plan. Remove some files or upgrade your plan to continue.
			<button
				type="button"
				class="underline font-medium hover:text-error-light"
				@click="emit('view-detail')"
			>
				View detail
			</button>
		</p>
	</div>
</template>

<style scoped></style>
